import {BrandPreview_Images} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand_preview.types';
import {COLORS, FullWidthImage, mobileOnly} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface BrandHubHeaderImageProps {
  images?: BrandPreview_Images;
  landscape: boolean;
}

export const BrandPageHeaderImage: React.FC<BrandHubHeaderImageProps> = ({
  images,
  landscape,
}) => {
  const imageData = landscape ? images?.landscapeImage : images?.portraitImage;

  return (
    <StyledFullWidthImage
      $increaseBottomOverlay
      dataTestId="brandHubHeaderImage"
      imageUrl={imageData?.url}
      description={imageData?.description}
      aspectRatio={landscape ? '4:1' : '5:4'}
      highPrioImage
    />
  );
};

const StyledFullWidthImage = styled(FullWidthImage)<{
  $increaseBottomOverlay: boolean;
}>`
  background-color: ${COLORS.Black};

  &::before {
    ${mobileOnly(css`
      content: '';
      position: absolute;
      width: 100%;
      height: 30%;
      z-index: 1;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.25) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    `)}
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to top, #000000 40%, rgba(0, 0, 0, 0) 100%);

    ${mobileOnly(
      css`
        background: linear-gradient(to top, #000000 55%, rgba(0, 0, 0, 0) 100%);
      `,
    )}
  }
`;
